import { $ } from '../vendors/jquery';

const mobMenuDropdowns = {
    init() {
        //Mobile Submenus
        $( '.bricks-mobile-menu-wrapper .menu-item-has-children>.brx-submenu-toggle>a').click( function( e ) {
            if ( window.innerWidth <= 991 ) {
                if ( !$( this ).hasClass( 'mobile-opened' ) ) {
                    e.preventDefault();
                    $( this ).addClass( 'mobile-opened' ).next( '.sub-menu' ).slideDown();
                    $( this ).closest( '.menu-item' ).addClass( 'mobile-opened' );
                }
            }
        } );
    }
};

export default mobMenuDropdowns;
